'use strict';
import * as $j_app$002edata$002e$002dOrganization$002dInfo$0024$0024anon$00241 from "./app.data.-Organization-Info$$anon$1.js";
import * as $j_app$002edata$002e$002dOrganization$002dInfo$0024$0024anon$00242 from "./app.data.-Organization-Info$$anon$2.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_OrganizationInfo(name, address, email, website, aboutUs, certificateOfOriginAuthority, originalWatermark, copyWatermark) {
  this.BF = null;
  this.LK = null;
  this.LM = null;
  this.LN = null;
  this.LJ = null;
  this.LL = null;
  this.Y8 = null;
  this.Y7 = null;
  this.BF = name;
  this.LK = address;
  this.LM = email;
  this.LN = website;
  this.LJ = aboutUs;
  this.LL = certificateOfOriginAuthority;
  this.Y8 = originalWatermark;
  this.Y7 = copyWatermark;
}
export { $c_Lapp_data_OrganizationInfo as $c_Lapp_data_OrganizationInfo };
$p = $c_Lapp_data_OrganizationInfo.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_OrganizationInfo;
/** @constructor */
function $h_Lapp_data_OrganizationInfo() {
}
export { $h_Lapp_data_OrganizationInfo as $h_Lapp_data_OrganizationInfo };
$h_Lapp_data_OrganizationInfo.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_OrganizationInfo)) {
    if ((((this.BF === x$0.BF) && (this.LK === x$0.LK)) && (this.LM === x$0.LM))) {
      var x = this.LN;
      var x$2 = x$0.LN;
      var $x_3 = ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      var $x_3 = false;
    }
    if (($x_3 && (this.LJ === x$0.LJ))) {
      var x$3 = this.LL;
      var x$4 = x$0.LL;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.Y8;
      var x$6 = x$0.Y8;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$7 = this.Y7;
      var x$8 = x$0.Y7;
      return ((x$7 === null) ? (x$8 === null) : x$7.f(x$8));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 8;
});
$p.t = (function() {
  return "OrganizationInfo";
});
$p.e = (function(n) {
  switch (n) {
    case 0: {
      return this.BF;
      break;
    }
    case 1: {
      return this.LK;
      break;
    }
    case 2: {
      return this.LM;
      break;
    }
    case 3: {
      return this.LN;
      break;
    }
    case 4: {
      return this.LJ;
      break;
    }
    case 5: {
      return this.LL;
      break;
    }
    case 6: {
      return this.Y8;
      break;
    }
    case 7: {
      return this.Y7;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.u = (function(n) {
  switch (n) {
    case 0: {
      return "name";
      break;
    }
    case 1: {
      return "address";
      break;
    }
    case 2: {
      return "email";
      break;
    }
    case 3: {
      return "website";
      break;
    }
    case 4: {
      return "aboutUs";
      break;
    }
    case 5: {
      return "certificateOfOriginAuthority";
      break;
    }
    case 6: {
      return "originalWatermark";
      break;
    }
    case 7: {
      return "copyWatermark";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.bYa = (function() {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector0$();
  return new $j_app$002edata$002e$002dOrganization$002dInfo$0024$0024anon$00241.$c_Lapp_data_OrganizationInfo$$anon$1().bwQ(this);
});
$p.bXO = (function() {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector0$();
  return new $j_app$002edata$002e$002dOrganization$002dInfo$0024$0024anon$00242.$c_Lapp_data_OrganizationInfo$$anon$2().bwR(this);
});
function $isArrayOf_Lapp_data_OrganizationInfo(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jI)));
}
export { $isArrayOf_Lapp_data_OrganizationInfo as $isArrayOf_Lapp_data_OrganizationInfo };
var $d_Lapp_data_OrganizationInfo = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_OrganizationInfo, "app.data.OrganizationInfo", ({
  jI: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_data_OrganizationInfo as $d_Lapp_data_OrganizationInfo };
//# sourceMappingURL=app.data.-Organization-Info.js.map
